import { MatterType } from "../models/MatterType";
import api from "./api";
import { clean } from "../utils/utils";
import { IntakeQuestion } from "../models/IntakeQuestion";
import { EventType } from "../models/EventType";
import { EventSubtype } from "../models/EventSubtype";

const PATH = "/api/v1/matter-types";

export const MatterTypeService = {
  async getMatterType(matterTypeId: string): Promise<MatterType | null> {
    try {
      const response = await api.get(`${PATH}/${matterTypeId}`);
      return response.data.data;
    } catch (err: any) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  },

  async getMatterTypeQuestions(
    matterTypeId: string,
  ): Promise<IntakeQuestion[] | null> {
    try {
      const response = await api.get(
        `${PATH}/${matterTypeId}/matter-type-questions`,
      );
      return response.data.data;
    } catch (err: any) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  },

  async getEventTypes(matterTypeId: string): Promise<EventType[] | null> {
    try {
      const response = await api.get(`${PATH}/${matterTypeId}/event-types`);
      return response.data.data;
    } catch (err: any) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  },

  async getEventSubtypes(matterTypeId: string): Promise<EventSubtype[] | null> {
    try {
      const response = await api.get(`${PATH}/${matterTypeId}/event-subtypes`);
      return response.data.data;
    } catch (err: any) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  },

  async getAllMatterTypes(): Promise<MatterType[]> {
    const res = await api.get(PATH);
    return res.data.data || [];
  },

  async createMatterType(
    matterTypeData: Omit<MatterType, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const response = await api.post(PATH, clean(matterTypeData));
    return response.data.data._id;
  },

  async updateMatterType(
    matterTypeId: string,
    file: globalThis.File | null,
    updatedData: Partial<Omit<MatterType, "_id" | "createdAt">>,
  ): Promise<void> {
    const formData = new FormData();
    if (file) formData.append("file", file);
    formData.append("name", updatedData.name!);
    if (updatedData.description)
      formData.append("description", updatedData.description);
    if (updatedData.qualifications)
      formData.append("qualifications", updatedData.qualifications);
    formData.append("isPrivate", updatedData.isPrivate ? "true" : "false");
    await api.put(`${PATH}/${matterTypeId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deleteMatterType(matterTypeId: string): Promise<void> {
    await api.delete(`${PATH}/${matterTypeId}`);
  },

  async deleteEventType(
    matterTypeId: string,
    eventTypeId: string,
  ): Promise<void> {
    await api.delete(`${PATH}/${matterTypeId}/event-types/${eventTypeId}`);
  },

  async deleteEventSubtype(
    matterTypeId: string,
    eventSubtypeId: string,
  ): Promise<void> {
    await api.delete(
      `${PATH}/${matterTypeId}/event-subtypes/${eventSubtypeId}`,
    );
  },
};
